/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_W3Inputs */

const en_mk_cmp_multica_w3 = /** @type {(inputs: Mk_Cmp_Multica_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source is non-negotiable — you want to read and change the code.`)
};

const id_mk_cmp_multica_w3 = /** @type {(inputs: Mk_Cmp_Multica_W3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber terbuka adalah syarat mutlak — Anda ingin bisa membaca dan mengubah kodenya.`)
};

/**
* | output |
* | --- |
* | "Open source is non-negotiable — you want to read and change the code." |
*
* @param {Mk_Cmp_Multica_W3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_w3 = /** @type {((inputs?: Mk_Cmp_Multica_W3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_W3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_w3(inputs)
	return en_mk_cmp_multica_w3(inputs)
});